import React, { useEffect, useRef } from "react";
import "ol/ol.css"; // OpenLayers default CSS
import Map from "ol/Map";
import View from "ol/View";
import TileLayer from "ol/layer/Tile";
import OSM from "ol/source/OSM";
import { fromLonLat } from "ol/proj";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import LineString from "ol/geom/LineString";
import { Style, Stroke, Circle, Fill } from "ol/style";
import { extend } from "ol/extent";

const LocationsMap = ({ busLines }) => {
  const mapRef = useRef(null);

  // School bus lines with stops
  //   const busLines = {
  //     Green: [
  //       {
  //         id: 1,
  //         name: "Stop 1",
  //         latitude: 30.094742,
  //         longitude: 31.247279,
  //         order: 1,
  //       },
  //       {
  //         id: 2,
  //         name: "Stop 2",
  //         latitude: 30.094971,
  //         longitude: 31.25262,
  //         order: 2,
  //       },
  //       {
  //         id: 3,
  //         name: "Stop 2",
  //         latitude: 30.096319,
  //         longitude: 31.24757,
  //         order: 2,
  //       },
  //       {
  //         id: 4,
  //         name: "Stop 2",
  //         latitude: 30.09405,
  //         longitude: 31.24621,
  //         order: 2,
  //       },
  //     ],
  //     Red: [
  //       {
  //         id: 5,
  //         name: "Stop A",
  //         latitude: 30.095313,
  //         longitude: 31.251874,
  //         order: 1,
  //       },
  //       {
  //         id: 6,
  //         name: "Stop B",
  //         latitude: 30.094029,
  //         longitude: 31.251725,
  //         order: 2,
  //       },
  //     ],
  //     Blue: [
  //       {
  //         id: 5,
  //         name: "Stop X",
  //         latitude: 30.096276,
  //         longitude: 31.248535,
  //         order: 1,
  //       },
  //       {
  //         id: 6,
  //         name: "Stop Y",
  //         latitude: 30.091996,
  //         longitude: 31.246977,
  //         order: 2,
  //       },
  //     ],
  //   };

  const lineColors = {
    Green: "green",
    Red: "red",
    Blue: "blue",
  };

  useEffect(() => {
    // Create a map instance
    const map = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
      ],
      view: new View({
        center: fromLonLat([-122.4194, 37.7749]), // Default center
        zoom: 13, // Default zoom
      }),
    });

    const overallExtent = [Infinity, Infinity, -Infinity, -Infinity]; // Initialize an empty bounding box

    // Add markers and routes for each line
    Object.keys(busLines).forEach((line) => {
      const stops = busLines[line];
      const lineSource = new VectorSource();

      // Add markers for stops
      stops.forEach((stop) => {
        const coord = fromLonLat([stop.longitude, stop.latitude]);

        // Update the overall extent to include this point
        extend(overallExtent, [coord[0], coord[1], coord[0], coord[1]]);

        const marker = new Feature({
          geometry: new Point(coord),
          name: stop.name,
        });

        marker.setStyle(
          new Style({
            image: new Circle({
              radius: 6,
              fill: new Fill({ color: lineColors[line] }),
              stroke: new Stroke({ color: "black", width: 1 }),
            }),
          })
        );

        lineSource.addFeature(marker);
      });

      // Add route (polyline) for the line
      const coordinates = stops
        .sort((a, b) => a.order - b.order)
        .map((stop) => fromLonLat([stop.longitude, stop.latitude]));
      const route = new Feature({
        geometry: new LineString(coordinates),
      });

      route.setStyle(
        new Style({
          stroke: new Stroke({
            color: lineColors[line],
            width: 3,
          }),
        })
      );

      lineSource.addFeature(route);

      // Add the line's layer to the map
      const lineLayer = new VectorLayer({
        source: lineSource,
      });
      map.addLayer(lineLayer);
    });

    // Fit the map view to the overall extent
    map.getView().fit(overallExtent, { padding: [50, 50, 50, 50] });

    return () => {
      map.setTarget(null); // Cleanup map instance on unmount
    };
  }, []);

  return (
    <div>
      <h1 className="text-center my-4">School Bus Pick-Up Locations</h1>
      <div
        ref={mapRef}
        style={{
          width: "100%",
          height: "500px",
        }}
      ></div>
    </div>
  );
};

export default LocationsMap;
